export function initSliderSimple($) {
  $('.slider-simple--slider').not('.slick-initialized').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    cssEase: 'ease-in-out',
    speed: 1000,
    // défilement automatique (désactivé si l'utilisateur demande moins d'animations)
    autoplay: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    nextArrow: $('.slider-simple--arrows .next'),
    prevArrow: $('.slider-simple--arrows .prev'),
  });


  // Désactive la nav si une slide uniquement
  $('.slider-simple').each(function(i, slider){
    var slidesCount = $(slider).find('.slider-simple--slide').length; 
    if( slidesCount < 2 ){
      $(slider).find('.slider-simple--arrows').addClass('d-none');
    }
  })

 
}
